import { DropdownButton } from "../../toolbar-buttons";
import style from "./mindmap-org-chart-fields-picker.module.css";
import { FieldSelection, FieldSelectionLoader } from "frontend/icons/orgchart-fields-selection";
import { useEffect, useState } from "react";
import tracking from "frontend/tracking";
import consts from "shared/consts";
import { useAtomValue } from "jotai";
import { boardAtom, smartOrgChartsIsFullyLoadedAtom, userAtom } from "state-atoms";
import { isSelectedChartDataFullyLoaded } from "frontend/canvas-designer-new/elements/org-chart/orgchart-utils";

export default function MindmapOrgChartFieldsPicker({
  value,
  onChange,
  tooltip,
  selectedIds,
}: {
  value: any; //{ id: string; selected: boolean; title: string; type: string }[];
  onChange: (value: string[]) => void;
  tooltip?: string;
  selectedIds?: string[];
}) {
  const chartsFullDataLoaded = useAtomValue(smartOrgChartsIsFullyLoadedAtom);

  function renderFieldsPopup() {
    return (
      <>
        <div className={style.checkboxDropdownContainer}>
          <div className={style.title}>Select info to present</div>
          <CustomCheckbox items={value} onChange={onChange} />
        </div>
      </>
    );
  }

  if (!isSelectedChartDataFullyLoaded(chartsFullDataLoaded, selectedIds)) {
    return (
      <div className={style.fieldSelectionLoaderContainer}>
        <FieldSelectionLoader size={20} />
      </div>
    );
  }

  return (
    <DropdownButton
      data-testid="orgchart-fields-picker-button"
      tooltip={tooltip ?? "Filter fields"}
      renderPopup={renderFieldsPopup}
      className={style.arrowBackground}
      arrowSize={12}
    >
      <FieldSelection size={20} />
    </DropdownButton>
  );
}

const CustomCheckbox = ({
  items,
  onChange,
}: {
  items: { id: string; selected: boolean; title: string; type: string }[];
  onChange: (value: string[]) => void;
}) => {
  const board = useAtomValue(boardAtom);
  const user = useAtomValue(userAtom);

  const [checkedItems, setCheckedItems] = useState<any>({});

  useEffect(() => {
    const itemsDict = items.reduce((acc: any, item: { id: string; selected: boolean }) => {
      acc[item.id] = item.selected;
      return acc;
    }, {});
    setCheckedItems(itemsDict);
  }, []);

  const handleChange = (event: { target: { id: string; checked: boolean } }) => {
    const { id, checked } = event.target;
    const newCheck = { ...checkedItems, [id]: checked };
    setCheckedItems(newCheck);
    tracking.trackEvent(
      consts.TRACKING_CATEGORY.ORG_CHART,
      checked ? "orgchart_field_display_added" : "orgchart_field_display_removed",
      board?.documentId,
      board?.accountId,
      user?.id
    );
    onChange(Object.keys(newCheck).filter((item_id) => newCheck[item_id]) as string[]);
  };

  return (
    <div className={style.checkbox}>
      {items.map((item) =>
        item.type == "subtasks" ? null : (
          <div key={item.id} style={{ height: "20px" }}>
            <input
              type="checkbox"
              id={item.id}
              name={item.title}
              checked={checkedItems[item.id] || false}
              onChange={handleChange}
            />
            <label htmlFor={item.id}>{item.title}</label>
          </div>
        )
      )}
    </div>
  );
};
